import React from 'react'
import styled from 'react-emotion'
import Avatar from 'common/components/Avatar'
import Text from 'common/components/Text'
import { Trans } from 'react-i18next'
import { border, space, interactive } from 'common/style'

const ActivityAvatar = styled(Avatar)({
  flexShrink: 0,
  marginRight: space.default
})
const ActivityTitle = styled(Text)({
  flex: 1,
  marginRight: space.default
})
const ActivityDetails = styled('div')({
  display: 'flex',
  marginBottom: space.default
})

const ActivityItem = styled(({ activityItem, onClick, className, t }) => (
  <div onClick={onClick} className={className}>
    <ActivityDetails>
      {activityItem.userId && <ActivityAvatar name={activityItem.userName} />}
      <ActivityTitle small>
        <Text grey={activityItem.read}>
          <Trans
            i18nKey={`activity.${activityItem.type}.title`}
            values={activityItem}
          >
            <Text medium>user</Text> did a thing at <Text medium>location</Text>
          </Trans>
        </Text>
      </ActivityTitle>
      {/* Date */}
      <Text grey small title={t('fullDate', { date: activityItem.date })}>
        {t('date', { date: activityItem.date })}
      </Text>
    </ActivityDetails>
    <Text small grey={activityItem.read}>
      {t(`activity.${activityItem.type}.message`, activityItem)}
    </Text>
  </div>
))(({
  label: 'ActivityItem',
  padding: space.default,
  borderBottom: border,
  ...interactive(),
  // make sure you can't see the bottom border of the last one
  // when scrolled to bottom, cant' remove border because last-child
  // might not be at the bottom of activity if there are only a few
  '&:last-child': { marginBottom: -1 }
}))

export default ActivityItem
